import React from 'react';
import ReactDOM from 'react-dom';
import './assets/styles/index.css';
import App from './App';
import * as serviceWorker from './services/serviceWorker';
import firebase from 'firebase/app';

import { isMobile } from './utils/device'

import PushContextProvider from './context/pushContext';
import NetworkStatusProvider from './hooks/useNetworkStatus';

// Interceptar /premio antes do React carregar
var str = window.location.pathname;
var s = str.toLowerCase();

var n = s.search("premio2021");
if (n > 0) {
  window.location.href = "https://www.maquinadecontos.com.br/premio2021/index.html";
} else {
  n = s.search("premio2022");
  if (n > 0) {
    window.location.href = "https://www.maquinadecontos.com.br/premio2022/index.html";
  } else {
    n = s.search("premio2023");
    if (n > 0) {
      window.location.href = "https://www.maquinadecontos.com.br/premio2023/index.html";
    } else {
      n = s.search("premio2024");
      if (n > 0) {
        window.location.href = "https://www.maquinadecontos.com.br/premio2024/index.html";
      } else {
        n = s.search("premio2025");
        if (n > 0) {
          window.location.href = "https://www.maquinadecontos.com.br/premio2025/index.html";
        } else {
          n = s.search("premio2026");
          if (n > 0) {
            window.location.href = "https://www.maquinadecontos.com.br/premio2026/index.html";
          } else {
            n = s.search("premio2027");
            if (n > 0) {
              window.location.href = "https://www.maquinadecontos.com.br/premio2027/index.html";
            } else {
              n = s.search("premio2028");
              if (n > 0) {
                window.location.href = "https://www.maquinadecontos.com.br/premio2028/index.html";
              } else {
                n = s.search("premio2029");
                if (n > 0) {
                  window.location.href = "https://www.maquinadecontos.com.br/premio2029/index.html";
                } else {
                  n = s.search("premio");
                  if (n > 0) {
                    window.location.href = "https://www.maquinadecontos.com.br/premio/index.html";
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

if (firebase.messaging.isSupported()) {
  const firebaseConfig = {
    apiKey: "AIzaSyAEonBu86N733AyeiMpDOv_kVWF49hJYXo",
    authDomain: "cov-producao.firebaseapp.com",
    projectId: "cov-producao",
    storageBucket: "cov-producao.appspot.com",
    messagingSenderId: "353661224917",
    appId: "1:353661224917:web:7249f6ba84b78a23ca1f5c",
    measurementId: "G-08P9WKP0K9"
  };

  firebase.initializeApp(firebaseConfig);
  firebase.analytics();

  const messaging = firebase.messaging();
  messaging.onMessage(function (payload) {
    if (payload?.data?.title && payload?.data?.body) {
      const { title, body } = payload?.data;

      const notification_options = {
        body,
        icon: 'https://dev.cov.n3r.com.br/logo512.png',
      }

      if (isMobile) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          if (registrations) {
            registrations[0].showNotification(title, notification_options);
          }
        });
      } else {
        new Notification(title, notification_options);
      }
    }

  });
}


ReactDOM.render(
	<PushContextProvider>
		<NetworkStatusProvider>
			<App />
		</NetworkStatusProvider>
	</PushContextProvider>
	, document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
